export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8675.9e9733c7.jpg";